import {createContext} from 'react';

import {ConfirmDispatch} from './state';

export const ConfirmationContext = createContext<{dispatch: ConfirmDispatch}>({
  dispatch: () => console.warn('confirmation dispatcher not passed through context'),
});
